module.exports = __webpack_public_path__ + "img/gcalendar.1777ff33.svg";